// extracted by mini-css-extract-plugin
export default {"root":"applications-components-common-SocialLinks-social-links-module__root"};
    if(module.hot) {
      // 1791528100694
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  